import { AxiosError } from "axios";
import Form230Server from "../../server/form230";
import { Form230Input } from "../../dtos/form230/input";
import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "..";

class Form230ServiceReader extends ServiceReader {}
class Form230ServiceCreator extends ServiceCreator {
  constructor(protected api: Form230Server) {
    super();
  }

  public async upload(
    name: string,
    email: string,
    file: File,
    gdpr: boolean
  ): Promise<string | null> {
    try {
      const response = await this.api.post(
        new Form230Input(name, email, file, gdpr)
      );

      if (response.status! / 100 === 2) return null;
      return `Error ${response.status!}: ${response.data!}`;
    } catch (error) {
      console.error(error);
      if (error instanceof AxiosError)
        return (
          "Error " +
          (error.response !== undefined
            ? error.response.status
            : error.status) +
          ": " +
          (error.response
            ? error.response.data
            : error.code
            ? error.code
            : "AXIOS_ERR")
        );
      throw error;
    }
  }
}
class Form230ServiceUpdater extends ServiceUpdater {}
class Form230ServiceDeleter extends ServiceDeleter {}

export default class Form230Service extends Service {
  constructor() {
    super(new Form230Server());
  }

  public get read(): Form230ServiceReader {
    return new Form230ServiceReader();
  }
  public get create(): Form230ServiceCreator {
    return new Form230ServiceCreator(this.api as Form230Server);
  }
  public get update(): Form230ServiceUpdater {
    return new Form230ServiceUpdater();
  }
  public get delete(): Form230ServiceDeleter {
    return new Form230ServiceDeleter();
  }
}
